import { StyledTheme } from '../interfaces';
import { css } from 'styled-components';

export const StyledThemeSizesMixin = css<{ theme: StyledTheme }>`
  &.sizeXS {
    & button,
    & select,
    & input,
    & label,
    & textarea,
    & .tip-message {
      font-size: ${({ theme }) => theme.sizing.fontXS}rem;
    }
  }
`;
